import { render, staticRenderFns } from "./view-audit-team.vue?vue&type=template&id=5817f3f0&scoped=true"
import script from "./view-audit-team.vue?vue&type=script&lang=js"
export * from "./view-audit-team.vue?vue&type=script&lang=js"
import style0 from "./view-audit-team.vue?vue&type=style&index=0&id=5817f3f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5817f3f0",
  null
  
)

export default component.exports